// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/social_links.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/social_links.proto.
 */
export const file_entities_app_my_account_social_links: GenFile = /*@__PURE__*/
  fileDesc("CiplbnRpdGllcy9hcHAvbXlfYWNjb3VudC9zb2NpYWxfbGlua3MucHJvdG8SHnByb3Rvcy5lbnRpdGllcy5hcHAubXlfYWNjb3VudCJSCgtTb2NpYWxMaW5rcxIRCglpbnN0YWdyYW0YASABKAkSEAoIZmFjZWJvb2sYAiABKAkSEAoIbGlua2VkaW4YAyABKAkSDAoEaW1kYhgEIAEoCWIGcHJvdG8z");

/**
 * @generated from message protos.entities.app.my_account.SocialLinks
 */
export type SocialLinks = Message<"protos.entities.app.my_account.SocialLinks"> & {
  /**
   * @generated from field: string instagram = 1;
   */
  instagram: string;

  /**
   * @generated from field: string facebook = 2;
   */
  facebook: string;

  /**
   * @generated from field: string linkedin = 3;
   */
  linkedin: string;

  /**
   * @generated from field: string imdb = 4;
   */
  imdb: string;
};

/**
 * Describes the message protos.entities.app.my_account.SocialLinks.
 * Use `create(SocialLinksSchema)` to create a new message.
 */
export const SocialLinksSchema: GenMessage<SocialLinks> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_social_links, 0);

